import Fab, {FabProps} from '@mui/material/Fab';
import {styled} from '@mui/material/styles';

export const CFab = styled(Fab)<FabProps>(
  (/* { theme } */) => ({
  }),
);
